// Application

var App = function(params){
	var self = this;

	self.csrf = params && params.csrf || {};
	self.user = new User(params && params.user || {});
	self.urls = params && params.urls || {};
	self.urls.ajax = self.urls.ajax || self.urls.base + 'ajax';

	self.ajaxRequest = function(action, params, callback) {
		if(typeof(params) === 'function') {
			callback = params;
			params = {};
		}
		var opts = {
			type: 'POST',
			data: $.extend(params||{}, self.csrf),
			dataType: 'json',
		};
		if(action) {
			if(action.substring(0, 1) === '/')
				opts.url = action;
			else
				opts.url = self.urls.ajax + '/' + action;
		}
		return $.ajax(opts).done(function(r){
            callback && callback(r);
		});
	};
};

// Knockout utils

ko.clearBindings = function($node){
	$($node).find("*").each(function(){
		$(this).unbind();
	});
	ko.cleanNode($node[0]);
};